import React from 'react'
import Typography from 'ui-components/lib/components/Typography'
const ConvertBytes = (props) => {
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return ''
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
  }
  return <Typography>{formatBytes(props.data) || '0KB'}</Typography>
}
export default ConvertBytes
